import { axiosRequest, type AxiosResult } from "@/lib/axios";
import type { FormPageField } from "../types";

const API_BASE_URL = import.meta.env.VITE_SERVICE_CORE_URL;

export interface FormPageFieldUpdateRequest {
	label?: string;
	placeholder?: string;
	is_required?: boolean;
	is_visible?: boolean;
	sort_order?: number;
}

export const formPageFieldApi = {
	update: (workspaceId: string, formId: string, formPageId: string, fieldId: string, payload: FormPageFieldUpdateRequest): Promise<AxiosResult<FormPageField>> => {
		return axiosRequest({
			method: "PATCH",
			url: `${API_BASE_URL}/${workspaceId}/forms/${formId}/pages/${formPageId}/fields/${fieldId}`,
			data: payload,
		});
	},
};
